module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.msg.pics[0],
      "alt": _vm.msg.productName
    }
  })])]), _vm._v(" "), _c('div', {
    class: [!this.showBtn && 'pr-n', 'good-price', 'pr']
  }, [_c('div', {
    staticClass: "ds pa"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "查看详情"
    }
  })], 1), _vm._v(" "), (!_vm.msg.nospec && _vm.msg.special_type == 'normal') ? [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": _vm.msg.special_type == 'drug' ? '加入预约单' : '加入购物车',
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.getSku(_vm.msg)
      }
    }
  })] : (!_vm.msg.nospec && _vm.msg.special_type == 'drug') ? [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": _vm.msg.special_type == 'drug' ? '加入预约单' : '加入购物车',
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.openProduct(_vm.msg)
      }
    }
  })] : [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": _vm.msg.special_type == 'drug' ? '加入预约单' : '加入购物车',
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": _vm.addCart
    }
  })]], 2), _vm._v(" "), _c('p', {
    staticClass: "price-info"
  }, [_vm._v("\n      " + _vm._s(_vm._f("priceFilter")(_vm.msg)) + "    \n      "), _c('span', [_vm._v(_vm._s(_vm._f("marketPriceFilter")(_vm.msg)))])])]), _vm._v(" "), _c('h4', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.item_name)
    }
  }, [_vm._v(_vm._s(_vm.msg.item_name))]), _vm._v(" "), (!Array.isArray(_vm.msg.distributor_info) && _vm.msg.distributor_info) ? _c('p', {
    staticClass: "distributor-info"
  }, [_vm._v(_vm._s(_vm.msg.distributor_info.name))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "good-item__tag"
  }, [(_vm.isShowActivityTag(_vm.msg)) ? [(_vm.isShowStypeActivityTag(_vm.msg)) ? _c('el-tag', {
    attrs: {
      "type": "danger",
      "effect": "dark",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm._f("filterActivityTag")(_vm.msg)))]) : _c('el-tag', {
    attrs: {
      "type": "danger",
      "size": "mini"
    }
  }, [_vm._v(_vm._s(_vm._f("filterActivityTag")(_vm.msg)))])] : _vm._e()], 2), _vm._v(" "), (!_vm.msg.nospec && _vm.msg.special_type == 'normal') ? [_c('el-dialog', {
    attrs: {
      "title": "加入购物车",
      "visible": _vm.skuDialogVisible,
      "width": "370px",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.skuDialogVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "flex line"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v("商品：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.msg.itemName))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-wrap"
  }, [_c('div', {
    staticClass: "flex line"
  }, [_c('div', {
    staticClass: "tag"
  }, [_vm._v("价格：")]), _vm._v(" "), _c('span', {
    staticClass: "price"
  }, [_vm._v(_vm._s(_vm._f("price")(_vm.msg.price)))])])]), _vm._v(" "), (!_vm.msg.nospec) ? _c('div', {
    staticClass: "classify-container"
  }, _vm._l((_vm.msg.item_spec_desc), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item-hd pt10 classify"
    }, [_c('span', {
      staticClass: "dt"
    }, [_vm._v(_vm._s(item.spec_name) + "：")]), _vm._v(" "), _c('div', {
      staticClass: "dd"
    }, [_c('div', {
      staticClass: "choose-attrs-list-wrap"
    }, [_vm._l((item.spec_values), function(attr) {
      return [_c('div', {
        staticClass: "choose-attrs-item",
        class: {
          'active': attr.spec_value_id == _vm.selectedAttr[index]
        },
        on: {
          "click": function($event) {
            return _vm.specBtnClick(attr.spec_value_id, index)
          }
        }
      }, [_c('div', {
        staticClass: "tick"
      }), _vm._v(" "), _c('span', {
        staticClass: "label"
      }, [_vm._v(_vm._s(attr.spec_value_name))])])]
    })], 2)])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('span', {
    staticClass: "params-name"
  }, [_vm._v("购买数量：")]), _vm._v(" "), _c('buy-num', {
    attrs: {
      "limit": Number(_vm.msg.store),
      "num": _vm.msg.operated_num
    },
    on: {
      "edit-num": _vm.editNum
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "store"
  }, [_vm._v("库存：" + _vm._s(_vm.msg.store))])], 1)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "加入购物车",
      "classStyle": _vm.btn_disabled ? 'disabled-btn' : 'main-btn'
    },
    on: {
      "btnClick": function($event) {
        return _vm.addCart(_vm.msg)
      }
    }
  })], 1)])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-237e1825","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/mallGoods.vue
// module id = 745
// module chunks = 0 1 2 3 4 5 7 9 13